export const UrbanizacionEntity = {
    id: null,
    nombre: '',
    ubicacion: '',
    enabled: true
};